import { encryptLeads } from "@repo/shared-utils/crypto";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { StockItem } from "../../types/stocks";
import {
  BUDGET_ETF_DEFAULT_LOGGED_IN_REDIRECTION_URL,
  BUDGET_ETF_DEFAULT_SCREEN,
} from "./BudgetETFTypes";

export interface BudgetEtfClickConfig {
  screen?: string;
  loggedInRedirectionUrl?: string;
  webViewTitle?: string;
}

export const handleBudgetEtfCardClick = async (
  stock: StockItem,
  config?: BudgetEtfClickConfig,
) => {
  if (!stock?.symbol || stock?.token == null) return;

  try {
    const { mobileNo } = await getSessionData();
    if (!mobileNo) {
      console.error("Mobile number not found");
      return;
    }

    const screen = config?.screen ?? BUDGET_ETF_DEFAULT_SCREEN;
    const title = config?.webViewTitle ?? "Bajaj Broking";

    const payload = {
      screen,
      token: String(stock.token),
      symbol: stock.symbol,
      mobileNo,
    };

    const encryptedPayload = await encryptLeads(JSON.stringify(payload));
    const url = new URL(
      config?.loggedInRedirectionUrl ?? BUDGET_ETF_DEFAULT_LOGGED_IN_REDIRECTION_URL,
    );
    url.searchParams.append("req", encryptedPayload);

    if (isOpenInApp()) {
      const windowWithTarsier = globalThis as unknown as Window & {
        tarsier?: {
          invokePrompt: (prompt: string, force?: boolean) => unknown;
        };
      };
      windowWithTarsier.tarsier?.invokePrompt(
        `openInAppWebViewActivity://${JSON.stringify({
          url: url.toString(),
          title,
        })}`,
        true,
      );
    } else {
      (globalThis as unknown as Window).open(url.toString(), "_blank");
    }
  } catch (error) {
    console.error("Error handling budget ETF card click:", error);
  }
};
